import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';
import PostControls from 'flarum/forum/utils/PostControls';
import Button from 'flarum/common/components/Button';
import ReplyComposer from 'flarum/forum/components/ReplyComposer';

app.initializers.add('rebk-moderator-replies', () => {

    extend(PostControls, 'moderationControls', function(items, post) {
        if (post.contentType() !== 'comment') {
            return;
        }

        const discussion = post.discussion();

        if (!discussion) {
            return;
        }

        const user = app.session.user;
        if (!user) {
            return;
        }

        const isAdmin = user.data?.attributes?.isAdmin;
        const groups = user.groups() || [];
        const isModerator = groups.some(function(g) {
            const name = g.nameSingular()?.toLowerCase();
            return name === 'moderator' || name === 'модератор';
        });

        if (!isAdmin && !isModerator) {
            return;
        }

        if (post.data.attributes.isModeratorReplyTo) {
            return;
        }

        if (post.data.attributes.moderatorReplyPostId) {
            return;
        }

        items.add(
            'moderator-reply',
            Button.component({
                icon: 'fas fa-reply',
                onclick: function() {
                    app.composer.load(ReplyComposer, {
                        user: app.session.user,
                        post: post,
                        discussion: discussion,
                        isModeratorReply: true,
                        targetPost: post
                    });

                    app.composer.show();
                }
            }, 'Ответить модератором')
        );
    });

    override(ReplyComposer.prototype, 'data', function(original) {
        if (this.attrs.isModeratorReply) {
            return null;
        }

        return original();
    });

    override(ReplyComposer.prototype, 'onsubmit', function(original) {
        if (this.attrs.isModeratorReply && this.attrs.targetPost) {
            const parentPost = this.attrs.targetPost;
            const content = this.composer.fields.content();

            if (!content || !content.trim()) {
                return;
            }

            this.loading = true;

            app.request({
                method: 'POST',
                url: app.forum.attribute('apiUrl') + '/posts/' + parentPost.id() + '/moderator-reply',
                body: {
                    data: {
                        attributes: {
                            content: content
                        }
                    }
                }
            }).then(
                function(response) {
                    app.composer.hide();
                    window.location.reload();
                },
                function(error) {
                    this.loading = false;
                    app.alerts.show({ type: 'error' }, app.translator.trans('core.lib.error.generic_message'));
                }.bind(this)
            );

            return;
        }

        return original();
    });

    extend(CommentPost.prototype, 'elementAttrs', function(attrs) {
        const post = this.attrs.post;
        const modReplyId = post.data.attributes.moderatorReplyPostId;
        const isModReplyTo = post.data.attributes.isModeratorReplyTo;

        if (!attrs.className) {
            attrs.className = '';
        }

        if (modReplyId) {
            attrs.className += ' has-moderator-reply';
        }

        if (isModReplyTo) {
            attrs.className += ' is-moderator-reply';
        }
    });

    console.log('Moderator Replies extension loaded');
});
